/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Quima_backend
 * OpenAPI spec version: v1
 */
import axios from 'axios';
import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';




  export const getWatchlist = (axiosInstance: AxiosInstance = axios) => {
/**
 * @summary Gets the watchlist for a specific user
 */
const getApiWatchlistUserId = (
    userId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/Watchlist/${userId}`,options
    );
  }
/**
 * @summary Adds an asset to a user's watchlist
 */
const postApiWatchlistUserIdAddAssetId = (
    userId: number,
    assetId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/Watchlist/${userId}/add/${assetId}`,undefined,options
    );
  }
/**
 * @summary Removes an asset from a user's watchlist
 */
const deleteApiWatchlistUserIdRemoveAssetId = (
    userId: number,
    assetId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.delete(
      `/api/Watchlist/${userId}/remove/${assetId}`,options
    );
  }
return {getApiWatchlistUserId,postApiWatchlistUserIdAddAssetId,deleteApiWatchlistUserIdRemoveAssetId}};
export type GetApiWatchlistUserIdResult = AxiosResponse<void>
export type PostApiWatchlistUserIdAddAssetIdResult = AxiosResponse<void>
export type DeleteApiWatchlistUserIdRemoveAssetIdResult = AxiosResponse<void>
